import { adminHttpClient } from "../commons/adminHttpClient";
import { httpClient } from "../commons/httpClient";

const auth = (username: string, password: string): Promise<any> => {
  return httpClient.post("/auth", { username, password });
};

export default auth;
